import { render } from "./ModaTransportasi.vue?vue&type=template&id=ea28f8f2"
import script from "./ModaTransportasi.vue?vue&type=script&lang=js"
export * from "./ModaTransportasi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__